"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var modal_1 = __importDefault(require("../../../plugins/modal"));
var loadingAnimationDivId = 'loading-modal-animation';
var LoadingModal = /** @class */ (function (_super) {
    __extends(LoadingModal, _super);
    function LoadingModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            didRequestClose: false,
        };
        _this.handleCloseClick = function () { return _this.setState(function (state) { return (__assign(__assign({}, state), { didRequestClose: true })); }); };
        _this.startLoadingAnimation = function () {
            window.initLottie(loadingAnimationDivId, window.accountApp.loadingAnimationPath);
        };
        return _this;
    }
    LoadingModal.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.isLoading !== this.props.isLoading) {
            this.setState(function (state) { return (__assign(__assign({}, state), { didRequestClose: false })); });
            if (this.props.isLoading) {
                // a bug in react means componentDidUpdate will fire before the DOM is ready
                setTimeout(this.startLoadingAnimation, 10);
            }
        }
    };
    LoadingModal.prototype.render = function () {
        var _a = this.props, error = _a.error, isLoading = _a.isLoading, loadingText = _a.loadingText;
        if (error) {
            console.log(error);
        }
        var errorMessage = this.props.errorMessage ? this.props.errorMessage : 'There was an error. Please check your input and try again.';
        return (React.createElement(modal_1.default, { disableClose: true, handleClose: function () { return null; }, isOpen: !!(isLoading || error) && !this.state.didRequestClose },
            React.createElement("div", { className: 'text-center padding-4' },
                error && (React.createElement("div", null,
                    React.createElement("div", { className: 'margin-bottom-6' }, errorMessage),
                    React.createElement("div", null,
                        React.createElement("a", { className: 'text-underline', onClick: this.handleCloseClick }, "Close")))),
                isLoading && (React.createElement("div", { className: 'text-center padding-bottom-4' },
                    React.createElement("div", { className: 'margin-vertical-4' }, loadingText || 'Loading, please wait...'),
                    React.createElement("div", { className: 'font-bold h7 text-sea-pink' }, "DO NOT CLOSE THIS WINDOW."),
                    React.createElement("div", { id: loadingAnimationDivId }))))));
    };
    return LoadingModal;
}(React.Component));
exports.default = LoadingModal;
